import {
    Grid, Typography, Button, Snackbar, Alert, Box, Dialog, DialogActions,
    DialogContent, DialogTitle, TextField, FormControl, InputLabel, Select
} from "@mui/material";
import { Save as IconSave } from "@mui/icons-material";
import { PaperComponentDraggable } from "./PaperComponentDraggable";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as salonService from "../services/salonService";
import * as filialService from "../services/filialService";

// Dialogo de mantenimiento de salon: codigo, descripcion, filial y estado.
const SalonEdit = ({ open, openClose, entity, setNewSaved, isReadOnly }) => {
    const idFilialUsuario = useSelector((state) => state.seguridad?.idFilial) || 0;
    const [codigo, setCodigo] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const [idFilial, setIdFilial] = useState(0);
    const [idEstado, setIdEstado] = useState(2);
    const [filiales, setFiliales] = useState([]);

    const [enabledSave, setEnabledSave] = useState(true);
    const [openMessage, setOpenMessage] = useState(false);
    const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });

    const isEdicion = (entity?.id || 0) > 0;
    const isDialogReadOnly = isReadOnly || !enabledSave;
    const onCloseMessage = () => setOpenMessage(false);

    useEffect(() => {
        if (!open) return;
        setEnabledSave(true);
        setCodigo(entity?.codigo || "");
        setDescripcion(entity?.descripcion || "");
        const fDef = (entity?.id || 0) > 0 ? (entity?.idFilial || 0) : (idFilialUsuario > 0 ? idFilialUsuario : (entity?.idFilial || 0));
        setIdFilial(fDef);
        setIdEstado(entity?.idEstado ?? 2);
        filialService.getFilialesList()
            .then((data) => setFiliales(filialService.soloFilialDelUsuario(data, idFilialUsuario)))
            .catch(() => setFiliales([]));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const advertir = (message) => {
        setPropsMessage({ severity: "error", message });
        setOpenMessage(true);
    };

    const postEntity = async () => {
        if (!codigo || codigo.trim() === "") { advertir("El codigo es obligatorio"); return; }
        if (!descripcion || descripcion.trim() === "") { advertir("La descripcion es obligatoria"); return; }
        if (!idFilial) { advertir("Seleccione la filial"); return; }

        try {
            const id = await salonService.addUpdateSalon({
                id: entity?.id || 0, idFilial, codigo, descripcion, idEstado
            });
            if (id > 0) {
                setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" });
                setOpenMessage(true);
                setEnabledSave(false);
                if (setNewSaved) setNewSaved();
            } else {
                advertir("No se pudo guardar");
            }
        } catch (e) {
            advertir("Hubo un error");
        }
    };

    return (
        <Dialog open={open} onClose={openClose} fullWidth={true} maxWidth={"sm"} PaperComponent={PaperComponentDraggable}>
            <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
                <Typography variant="h5" component="span">
                    <Box sx={{ fontWeight: "bold" }}>
                        {(isEdicion ? "Editar " : "Registrar ") + "Salon"}
                    </Box>
                </Typography>
            </DialogTitle>
            <DialogContent style={{ minHeight: "280px" }}>
                <div>
                    <Typography gutterBottom component="span">
                        <Box textAlign="center" padding={1}>
                            <Button variant="outlined" size="small" onClick={postEntity} disabled={isDialogReadOnly}>
                                Guardar
                                <IconSave />
                            </Button>
                        </Box>
                    </Typography>

                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={4}>
                            <TextField label="Codigo" value={codigo} fullWidth size="small"
                                onChange={(e) => setCodigo(e.target.value)} disabled={isDialogReadOnly} />
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <TextField label="Descripcion" value={descripcion} fullWidth size="small"
                                onChange={(e) => setDescripcion(e.target.value)} disabled={isDialogReadOnly} />
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <FormControl fullWidth size="small" disabled={isDialogReadOnly || idFilialUsuario > 0}>
                                <InputLabel shrink>Filial</InputLabel>
                                <Select native size="small" value={idFilial}
                                    onChange={(e) => setIdFilial(parseInt(e.target.value) || 0)}>
                                    {idFilialUsuario <= 0 && <option value={0}>{"(Seleccione)"}</option>}
                                    {filiales.map((f) => (<option key={f.id} value={f.id}>{f.descripcion}</option>))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth size="small" disabled={isDialogReadOnly}>
                                <InputLabel shrink>Estado</InputLabel>
                                <Select native size="small" value={idEstado}
                                    onChange={(e) => setIdEstado(parseInt(e.target.value))}>
                                    <option value={2}>{"Activo"}</option>
                                    <option value={3}>{"Inactivo"}</option>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Typography component="span">
                        <Box textAlign="center" padding={1}>
                            <Button variant="outlined" size="small" onClick={postEntity} disabled={isDialogReadOnly}>
                                Guardar
                                <IconSave />
                            </Button>
                        </Box>
                    </Typography>

                    <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
                        anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                        <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
                            {propsMessage.message}
                        </Alert>
                    </Snackbar>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={openClose}>Aceptar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default SalonEdit;
